import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filter-grid',
  templateUrl: './filter-grid.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './filter-grid.component.scss',
})
export class FilterGridComponent implements OnInit {
  @Input() gridColumns: { header: string; label: string }[] = [];
  @Input() gridData: any[] = [];
  @Input() page: string = '';
  @Output() onSelectRow = new EventEmitter<any>();
  @Input() searchTerm = '';
  totalResults: number = 0;
  pageSize: number = 50;
  pageOffset: number = 0; // Default page offset
  pageIndex: number = 0;
  currentSortColumn: string = 'TaskId';
  currentSortDirection: string = 'desc';
  selectedRow: any;
  displayedColumns: string[] = this.gridColumns.map((col) => col.header);
  key: string = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.totalResults = this.gridData.length;
    console.log(this.gridColumns);
  }

  onSort(sort: any): void {
    if (!sort.column || sort.direction === '') {
      this.gridData = this.gridData;
      return;
    }

    this.gridData = this.gridData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return this.compare(a.id, b.id, isAsc);
        case 'creationDate':
          return this.compare(a.creationDate, b.creationDate, isAsc);
        default:
          return 0;
      }
    });
    this.currentSortColumn = sort.column;
    this.currentSortDirection = sort.direction;
  }

  compare(a: number | string, b: number | string, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // openDetails(){
  //   this.router.navigate([
  //     '/klusup/accounting/account/account-details/',
  //     row.id,
  //   ]);
  // }

  onPageChange(page: any): void {
    this.gridData = [];
    this.pageSize = page.pageSize; // Update page size if needed
    this.pageOffset = page.pageIndex * this.pageSize; // Calculate page offset for API calls
  }

  select(row: any) {
    // Toggle the selected row
    this.selectedRow = this.selectedRow !== row ? row : null;

    // if (this.searchTerm.includes(':')) {
    //   // Get the key and the value from the searchTerm
    //   const parts = this.searchTerm.split(':');
    //   const key = parts[0];
    //   const value = parts[1];

    //   // Find the actual key in the row object that matches the case-insensitive search
    //   const actualKey = Object.keys(row).find(
    //     (k) => k.toLowerCase() === key.toLowerCase(),
    //   );

    //   if (actualKey) {
    //     // Create an object with the original key and the corresponding value from the selected row
    //     const rowData = {
    //       key: actualKey,
    //       value: row[actualKey],
    //     };
    //     this.onSelectRow.emit(rowData);
    //   } else {
    //     // Handle case where the key is not found in the row
    //     console.warn(`Key "${key}" not found in row data.`);
    //     this.onSelectRow.emit(null);
    //   }
    // } else {
    // If it's a general search, emit the full row
    this.onSelectRow.emit(this.selectedRow);
    // }
  }

  findKeyAndValue(
    obj: any,
    key: string,
    input: string,
  ): { key: string; value: any } | null {
    // If a specific key is provided, use it
    if (key && obj[key]) {
      const value = obj[key];
      const stringValue = String(value).toLocaleLowerCase();

      if (stringValue.includes(input.toLowerCase())) {
        return { key, value };
      }
    }

    // Fallback to searching all keys if the provided key doesn't match
    const lowerInput = input.toLowerCase();
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        const stringValue = String(value).toLocaleLowerCase();

        if (stringValue.includes(lowerInput)) {
          return { key: prop, value: value };
        }
      }
    }

    return null;
  }

  // select(row: any) {
  //   let rowData;
  //   this.selectedRow = this.selectedRow != row ? row : this.selectedRow;
  //   if (this.searchTerm.includes(':')){
  //     this.key = this.searchTerm.split(':')[0];
  //     this.searchTerm = this.searchTerm.includes(':')
  //       ? this.searchTerm.split(':')[1]
  //       : this.searchTerm;
  //    rowData = this.findKeyAndValue(this.selectedRow, this.searchTerm);
  //       this.onSelectRow.emit(rowData);
  //   } else
  //   this.onSelectRow.emit(this.selectedRow);
  // }

  // findKeyAndValue(obj: any, input: string): { key: string; value: any } | null {
  //   const lowerInput = input.toLowerCase(); // Convert input to lowercase once
  //   for (const key in obj) {
  //     if (Object.prototype.hasOwnProperty.call(obj, key)) {
  //       const value = obj[key];
  //       // Convert the value to a string for comparison
  //       const stringValue = String(value).toLocaleLowerCase();

  //       if (stringValue.includes(lowerInput)) {
  //         return { key, value };
  //       }
  //     }
  //   }
  //   return null;
  // }
}
